module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infos-card"
  }, [_c('export-dialog', {
    ref: "export-dialog",
    attrs: {
      "loading": _vm.exportLoading
    },
    on: {
      "update:loading": function($event) {
        _vm.exportLoading = $event
      }
    }
  }), _vm._v(" "), _c('record-dialog', {
    ref: "record-dialog"
  }), _vm._v(" "), _c('div', {
    staticClass: "project-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-wrapper"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": '//qrcode.ppj.io/' + _vm.project.viewer_url
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('qrcode.project')))]), _vm._v(" "), _c('div', {
    staticClass: "link-info"
  }, [_c('el-input', {
    staticClass: "link-input",
    attrs: {
      "placeholder": _vm.$t('placeholder.project.viewer_url'),
      "readonly": ""
    },
    model: {
      value: (_vm.project.viewer_url),
      callback: function($$v) {
        _vm.project.viewer_url = $$v
      },
      expression: "project.viewer_url"
    }
  }, [_c('div', {
    staticClass: "append-buttons",
    slot: "append"
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.project.viewer_url),
      expression: "project.viewer_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "copy el-button"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.buttons.copy')) + "\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "preview el-button",
    attrs: {
      "href": _vm.project.viewer_url,
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.buttons.preview')) + "\n          ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "buttons-group"
  }, [(!_vm.tbcMode && !_vm.readonly) ? _c('el-dropdown', {
    attrs: {
      "menu-align": "start"
    },
    on: {
      "command": _vm.exportDropdownCommand
    }
  }, [_c('el-button', {
    staticClass: "export-downdir-btn",
    attrs: {
      "plain": true,
      "type": "info"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-down-dir"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "export-btn",
    attrs: {
      "plain": true,
      "loading": _vm.exportLoading,
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.openExportDialog('html5')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.exportLoading ? '加载中' : _vm.$t('common.buttons.export.html5')) + "\n      ")]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "export-dropdown-menu",
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticClass: "export-dropdown-item",
    attrs: {
      "command": "scorm"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("common.buttons.export.scorm")) + "\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1392f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/infos/index.vue
// module id = 930
// module chunks = 3